/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'eye-off-icon': {
    width: 25,
    height: 25,
    viewBox: '0 0 25 25',
    data: '<g clip-path="url(#clip0_7792_169844)" _stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M18.005 18.518a10.07 10.07 0 01-5.94 2.06c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94m3.84-1.82a9.12 9.12 0 012.1-.24c7 0 11 8 11 8a18.502 18.502 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24M1.064 1.578l22 22"/></g><defs><clipPath id="clip0_7792_169844"><path pid="1" _fill="#fff" transform="translate(.064 .578)" d="M0 0h24v24H0z"/></clipPath></defs>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/eye-off-icon.js